import { getThemeCSSVariables, cssVariablesToString } from './component-lib.esm3.js';
function headCss(theme) {
  const variables = getThemeCSSVariables(theme);
  const styles = `
  :root {
    ${cssVariablesToString(variables)}
    --g-transition-speed: ${theme.transitionSpeed};
  }
  `;
  return {
    hid: 'head-css',
    innerHTML: styles
  };
}
export { headCss };